import React from "react";

export default function FieldLabel({ icon: Icon, children, className = "", ...props }) {
  return (
    <div className={`field-label ${className}`.trim()} {...props}>
      {Icon ? <Icon className="field-icon" /> : null}
      <span>{children}</span>
    </div>
  );
}
